var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { SiteHeaderLayout } from './site-header-layout';
import { ExplorerEntityDetailsLayout, ExplorerEntityDetailsLayoutDefaultProps } from '../explorer/explorer-entity-details-layout';
import { ExplorerProviders } from '../context/explorer-context';
import { GridLoader } from '../elements/grid-loader';
import { ExplorerTabs } from '../explorer';
import { ComponentPropsProvider } from '../context/component-props-context';
var cls = classNames('person-explorer-layout');
export var EntityExplorerLayoutDefaultProps = __assign({}, ExplorerEntityDetailsLayoutDefaultProps);
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    min-height: calc(100vh - 330px);\n  "], ["\n    min-height: calc(100vh - 330px);\n  "])))
});
var TabsStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled(SiteHeaderLayout)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Layout: styled(ExplorerEntityDetailsLayout)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Tabs: styled(ExplorerTabs)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles),
  Loader: styled(GridLoader)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles)
};
export var EntityExplorerLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    loading = props.loading,
    rest = __rest(props, ["className", "entity", "loading"]);
  return React.createElement(ExplorerProviders, null, React.createElement(ComponentPropsProvider, {
    value: {
      EntityBanner: {
        showColorStrip: false
      }
    }
  }, React.createElement(My.Container, null, React.createElement(My.Header, null), React.createElement(My.Tabs, {
    useStickyStyle: true
  }), loading ? React.createElement(My.Loader, null) : React.createElement(My.Layout, __assign({}, rest, {
    stickyTopOffset: 110,
    showAsideHeader: false,
    entity: entity,
    className: cls.name(className),
    isAsideSticky: false
  })))));
};
export var EntityExplorerLayoutWithoutBanner = function (props) {
  return React.createElement(EntityExplorerLayout, __assign({}, props, {
    showBanner: false
  }));
};
EntityExplorerLayout.defaultProps = EntityExplorerLayoutDefaultProps;
EntityExplorerLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;